/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BillableServicesQuarterControllerService } from './services/billable-services-quarter-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BillableServicesQuarterControllerService,
    ApiConfiguration
  ],
})
export class BillableServiceQuarterModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BillableServiceQuarterModule> {
    return {
      ngModule: BillableServiceQuarterModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BillableServiceQuarterModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BillableServiceQuarterModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
